export const formatPercentage = (pct: number, precision: number = 2) => {
  if (isNaN(pct)) return "0%";
  return `${(pct * 100).toLocaleString(undefined, {
    maximumFractionDigits: precision,
  })}%`;
};
